export default {
    abonplata: "Абоненттик төлөм",
    absent: "Жок",
    access_restriction: "Жеткиликтүүлүктү чектөө",
    accountant_fio: "Башкы бухгалтердин аты-жөнү",
    accrue_bonuses_on_bonus_payments: "Бонустар менен төлөөгө бонустарды эсептөө",
    acquiring_fee: "Эквайрингдин % ",
    activate_bonus_system: "Бонус системасын активдештирүү",
    add_field: "Багытты кошуу",
    add_user: "Колдонуучуну кошуу",
    additional_doctors: "Кошумча дарыгерлер",
    additional_green_api: "Кошумча Green API",
    additional_green_api_max: "Кошумча Green API Max",
    additional_green_api_telegram: "Кошумча Green API Telegram",
    additional_jet_api: "Кошумча JET API",
    additional_modules: "Кошумча модулдар",
    additional_partner_api: "Кошумча api өнөктөштүк",
    additional_space: "Кошумча орун",
    admins_limit: "Администраторлордун лимити",
    Advance: "Депозит",
    advance_calculated: "Депозит",
    advance_payment: "Бир жолку төлөм",
    after_discounts: "Арзандатуулардан кийин",
    after_technic_deduction: "Техникти эсептен чыгаруудан кийин",
    after_visit: "Визиттен кийин эскертүү",
    after_visit_day_passed: "Визиттен кийин (дароо эле)",
    AgreementDocument: "Макулдук шаблону",
    akt_text: "Көрсөтүлгөн кызматтардын актысына белги коюу",
    all_administrators: "Бардык администраторлор",
    all_rights: "Бардык укуктар",
    all_visits: "Бардык жазылуулар",
    allow: "Уруксат берүү",
    allow_negative_deposits: "Депозиттерди терс эсептен чыгарууга уруксат берүү",
    allow_opening_several_visits_at_the_same_time: "Бир эле учурда бир нече визиттин ачылышына уруксат берүү",
    allowed_ips: "Аккаунтка кирүүнү мүмкүн кылуучу IP даректер",
    api: "API",
    api_token: "API токени",
    are_you_sure_you_want_to_delete_branch: "Сиз чындыгында филиалды жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_company: "Сиз чындыгында компанияны жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_notification: "Сиз чындыгында билдирмени жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_source: "Сиз чындыгында булакты жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_tag: "Сиз чындыгында белгини жок кылгыңыз келеби?",
    ask_for_more: "Кайта суроо",
    ask_reason_cancel: "Визитти жокко чыгаруунун себебин суроо",
    ask_reason_not_come: "'келген жок' статусунун себебин суроо",
    ask_reason_reschedule: "Визитти кийинкиге жылдыруу себебин суроо",
    assistants_connected: "Жардамчылар модулу туташты",
    automatic_conflict_task_creation: "Ырааттама боюнча карама-каршылыктар пайда болгондо автоматтык түрдө тапшырма түзүү",
    available_disk_space: "Жеткиликтүү диск мейкиндиги, МБ (0 - безлимит)",
    before_discounts: "Арзандатууларга чейин",
    before_technic_deduction: "Техникти эсептен чыгаруудан кийин",
    before_visit: "Визиттен кийин эскертүү",
    before_visit_day_in_advance: "Бир күн мурун визит жөнүндө эскертүү (дароо эле)",
    billing: "Биллинг",
    billing_payment: "Төлөм",
    billing_turned_off: "Эсеп коюу өчүрүлгөн",
    bonus: "Бонус",
    bonus_accrued: "Бонустар эсептелген",
    bonus_adjustment: "Бонустарды тууралоо",
    bonus_payment: "Бонус менен төлөө",
    bonus_percent_can_be_used: "Бонустар менен төлөнө турган сатуунун максималдуу үлүшү",
    bonus_percent_of_cheque: "Сатуу бонустарынын пайызы",
    bonus_system: "Бонустук система",
    bonuses: "Бонустар",
    bonuses_payment: "Бонустар менен төлөө",
    branch_address: "Филиалдын дареги",
    branch_contacts: "Филиалдын байланыштары",
    branch_inn: "Филиалдын ЖСТН",
    branches: "Филиалдар",
    branches_connected: "Акы төлөнүүчү Филиалдар модулу иштетилди",
    by_chairs: "Креслолор боюнча",
    calendar_text_color: "Календардагы тексттин түсү",
    calendar_view_by_default: "Демейки боюнча календарь көрүнүшү",
    cancel_and_move_reason: "Жокко чыгаруунун жана жылдыруунун себеби",
    cancel_and_move_reasons: "Жокко чыгаруунун жана жылдыруунун себеби",
    change_tariff: "Тарифти өзгөртүү",
    cities: "Шаарлар",
    city: "Шаар",
    client_tag: "Белги",
    ClientDocument: "Бейтаптын документи",
    ClientNote: "Эскертме",
    ClientTag: "Бейтаптын теги",
    clinic: "Клиника",
    clinic_data: "Клиника тууралуу маалымат",
    clinic_inn: "Клиниканын ЖСТН",
    clinic_is_blocked: "Клиника бөгөттөлгөн",
    clinic_name: "Клиниканын аталышы",
    clinic_name_in_cheque: "Чектеги клиниканын аталышы",
    ClinicAdditional: "Клиниканын кошумча жөндөөлөрү",
    clinics: "Клиникалар",
    ClinicTariff: "Клиниканын тарифи",
    close: "Жабуу",
    cloud_space: "Булуттагы орун",
    communications: "Коммуникациялар",
    company_data: "Компания тууралуу маалымат",
    ComplexService: "Комплекстүү кызмат",
    configuration: "Конфигурация",
    connected_successfully: "Ийгиликтүү туташтырылды",
    connection_failed: "Байланыш катасы",
    control_system: "Көзөмөлдөө системасы",
    countries: "Өлкөлөр",
    country: "Өлкө",
    crm_application_created: "CRM-де өтүнмө түзүү",
    crm_connected: "Акы төлөнүүчү CRM модулу туташтырылды",
    Curator: "Куратор",
    currency_rates: "Валюта курстары",
    CustomRole: "Роль",
    data: "Маалыматтар",
    date_of_registration: "Каттоо датасы",
    day: "Күн",
    deduct_acquiring_from_salary: "Эмгек акыдан эквайрингди алып салуу",
    deduct_warranty_from_salary: "Кепилдик иши боюнча кызматкерлердин эмгек акысын эсептебөө",
    deleted: "Өчүрүлгөн",
    demo: "Демо",
    DepositByAccount: "Эсеп боюнча депозит",
    director_data: "Жетекчи тууралуу маалымат",
    director_fio: "Директордун аты-жөнү",
    disk_space_limit: "Диск мейкиндигинин лимити (Мб)",
    do_not_deduct_acquiring_from_technic_absolute: "Абсолюттук чегерүү менен техниктерден эквайрингди эсептен чыгарбоо",
    do_not_send_notifications_if_period_passed: "Эгер мөөнөтү өтүп кеткен болсо, визит жөнүндө эскертүү жөнөтпөңүз",
    do_not_show: "Көрсөтпө",
    Doctor: "Дарыгер",
    'doctor-services': "Дарыгер - кызматтар",
    DoctorAssistant: "Жардамчы",
    doctors_limit: "Дарыгерлердин лимити",
    DoctorScheduleConfiguration: "Дарыгердин графигинин жөндөөсү",
    DogovorDocument: "Келишим шаблону",
    DynamicConfig: "Конфигурация",
    egisz_prod: "ССЧБММС күжүрмөн режиминде",
    EGISZRecord: "ЕГИСЗге жөнөтүү",
    enter_ip_address: "IP-дарегин киргизүү",
    error_code: "Ката коду",
    field_configuration_in_diary: "Күндөлүктө талааларды орнотуу",
    field_configuration_in_teeth_general: "Тиштин тактасындагы General Fields орнотуу",
    field_configurations_in_description: "Талаа конфигурациялары сүрөттөмөдө",
    field_configurations_in_teeth: "Талаа конфигурациялары тиштерде",
    finance: "Каржы",
    free: "Акысыз",
    free_day: "Акысыз күн",
    general: "Жалпы",
    GeneratedDocument: "Түзүлгөн документ",
    has_additional_doctors: "Кошумча дарыгерлер бар",
    higher_number_higher_priority: "Номер канчалык жогору болсо, тизмедеги параметр ошончолук жогору болот",
    hour: "саат",
    hours: "саат",
    image_hidden: "Сүрөт жашырылган",
    in_development: "Иштеп чыгууда",
    insurance_company: "Камсыздандыруучу компания",
    integrations: "Интеграциялар",
    interface: "Интерфейс",
    ioka: "Ioka",
    ip_note: "Программага кирүү мүмкүнчүлүгүн жоготуп албаш үчүн IP дарегин киргизүүдө этият болуңуз. Клиникада статикалык IP дареги болгон учурда гана колдонсо болот.",
    jetapi_connected: "JET API модулу туташтырылды",
    'kit materials sync': "Материалдарды топтом менен байланыштыруу",
    kpp: "КПП",
    last_login: "Акыркы киргизүү",
    legal_address: "Юридикалык дарек",
    legal_name: "Юридикалык аталыш",
    license: "Лицензия",
    license_issue_body: "Ким тарабынан лицензия берилген",
    license_issue_date: "Лицензия берилген датасы",
    license_num: "Лицензия #",
    location_on_map: "Картада жайгашкан жери",
    logo: "Логотип",
    logout_interval_timeout: "Аракетсиз программадан чыгуу интервалы (администраторлордун каттоо эсептери үчүн)",
    logs: "Логи",
    logs_journal: "Аракеттер журналы",
    Manager: "Администратор",
    manager2: "Менеджер",
    manual: "Кол менен",
    max_doctor_amount: "Дарыгерлердин максималдуу саны",
    max_qr_instructions: "Телефонуңуздагы QR кодун Max колдонмосунан окуңуз",
    min: "минута",
    min_symbols: "Минималдуу символдор",
    minute: "минута",
    minutes: "минута",
    model_id: "Моделдин Id",
    model_type: "Моделдин түрү",
    month: "Ай",
    monthly_payment: "Айлык төлөм",
    months_to_consider_patient_lost: "Бейтап жоголгон деп эсептелген айлардын саны",
    more_than_one_day: "Бир күндөн ашык",
    more_than_one_visit: "Бир визиттен ашык",
    next_payment: "Кийинки төлөм",
    not_connected: "Туташтырылган эмес",
    notification_channel: "Жеткирүү түрү",
    notification_setting: "Билдирүү",
    notification_type: "Билдирүү түрү",
    notifications: "Билдирүүлөр",
    NotificationSetting: "Билдирүү",
    NotificationWaitingResponse: "Ырастоо билдирүүсү күтүлүүдө",
    occupied: "Бош эмес",
    of_few_hours: "саат",
    ogrn: "НМКН",
    oid_ministry_rf: "РФ саламаттык сактоо министрлигинин OID",
    on: "Киргизилген",
    on_pay_page: "Төлөө барагына",
    online_booking: "Онлайн-жазылуу",
    online_booking_activate: "Онлайн-жазылууну активдештирүү",
    online_booking_categories: "Кызматтар категорияларын көрсөтүү",
    online_booking_feedbacks: "Сын-пикирлердин иштешин жактивдештирүү",
    online_booking_map: "Филиалдын картасын көрсөтүү",
    online_booking_max_days: "Күн менен эсептелген максималдуу жазылуу мөөнөтү",
    online_booking_path: "Бейтаптын онлайн жазылуу аркылуу сапары",
    online_booking_time: "Календарда убакытты ээлөө керекпи же жокпу",
    only_after_accordance_with_trustme: "trustme.kz менен макулдашылгандан кийин гана",
    only_after_payment_received: "Бейтаптан төлөмдү алгандан кийин гана",
    paid_functionality: "Төлөнүүчү функционал",
    paid_till: " чейин төлөнгөн",
    paid_with_bonus: "Бонустар менен төлөнөт",
    partner_api_limit: "Акысыз өнөктөш API чеги",
    Patient: "Бейтап",
    patient_conditions: "Бейтаптардын абалы",
    patient_sources: "Бейтаптардын булактары",
    PatientComment: "Бейтаптын комментарийи",
    patients_import: "Бейтаптарды импорттоо",
    pay: "Төлөө",
    pay_methods: "Төлөмдүн ыкмасы",
    pay_methods_acquiring: "Эквайинг терминалына которуу үчүн төлөм ыкмалары",
    pay_methods_cash: "Накталай акча катары көрсөтүлгөн төлөм ыкмалары",
    pay_system: "Төлөм системасы",
    payable: "Төлөнүүчү",
    Payment: "Төлөм",
    payment_id: "Төлөмдүн Id оплаты",
    percent_accrual_for_administrator: "Администраторлорго пайыздарды чегерүү",
    percent_accrual_for_personnel: "Персоналга пайыздарды чегерүү",
    period_by_default: "Демейки боюнча мезгил",
    permanent_patients_hint: "Бейтап туруктуу деп эсептелеби а) эгерде ал келди деген статусу менен экиден кем эмес визити бар учурда же эсепте кызматтары болгон учурда, бир күндүн ичинде болсо да  б) эгерде анда визиттер менен жок дегенде эки башка кун болгон учурда ",
    plan_treatment_text: "Дарылоо планына белгилөө",
    PlanSession: "Дарылоо планынын этабы",
    PlanTreatment: "Дарылоо планы",
    popup: "Попап",
    Price: "Прайс позициясы",
    price_per_additional_doctor: "Кошумча дарыгердин баасы",
    price_per_additional_partner_api: "Кошумча өнөктөш api баасы",
    price_per_additional_space: "Кошумча орун үчүн баа (100 Мб)",
    program_language: "Программанын тили",
    prolong: "Узартуу",
    purchase: "Сатып алуу",
    recipient: "Алуучу",
    Record: "Жазылуу",
    record_tag: "Визиттер үчүн ярлык",
    record_tags: "Визиттер үчүн ярлык",
    record_timing_enabled: "'визиттердин башталышы жана аяктоосу' башкаруу системасы",
    record_types: "Жазылуулардын түрү",
    RecordTooth: "Тиш",
    reject: "Четке кагуу",
    required_fields_to_close_visit: "Визитти жабуу үчүн талап кылынган талаалар",
    requires_payment: "Кошумча төлөм талап кылынат",
    reset_verb: "Калыбына келтирүү",
    right: "Укук",
    rights: "Укуктар",
    salary_accrual: "Дарыгерлер/администраторлор/кураторлор үчүн пайыздарды эсептөө логикасы",
    salary_accrual_for_personnel: "Дарыгерлер/администраторлор/кураторлор үчүн эмгек акысын эсептөө",
    salary_accrual_for_personnel_with_assistants: "Дарыгерлердин/администраторлордун/кураторлордун/жардамчылардын эмгек акысы",
    salary_accrual_for_technics: "Техникалык кызматкерлердин эмгек акысын эсептөө",
    salary_accrual_with_assistants: "Дарыгерлер/администраторлор/кураторлор/жардамчылар үчүн пайыздарды эсептөө логикасы",
    save_settings: "Жөндөөлөрдү сактоо",
    Scan: "Скан",
    send_time: "Жөнөтүү убактысы",
    sending_after_save_or_finish: "Визиттин жыйынтыгын суроо / документти ССЧБММС-на басуу аркылуу жөнөтүү:",
    sendouts_only_in_day_time: "Массалык каттарды күндүз жөнөтүңүз (09.00 - 22.00)",
    server_error: "Система сиздин өтүнмөңүздү аткара алган жок. Сураныч, кайра аракет кылыңыз же колдоо кызматына кайрылыңыз",
    services_import: "Кызматтарды импорттоо",
    'services-doctor': "Кызматтар - дарыгер",
    short_title: "Кыскартылган аталышы",
    show_complex_materials_for_teeth: "Дарылоо карточкасындагы \"Тиштер\" өтмөгүндө топтомдорду жана материалдарды көрсөтүү",
    show_description_in_forms: "043, 058 форматында визит комментарийлерин, дарылоо тарыхын көрсөтүү",
    show_doctor_in_documents: "Документтерди басып чыгарууда дарыгерге көрсөтүңүз",
    show_images: "Сүрөттөрдү көрсөтүү",
    show_preinstalled_templates: "Алдын ала коюлган шаблондорду көрсөтүү",
    show_service_classificator_data_in_documents: "Классификациялоочудан басылган документтерде кызматтын кодун жана атын колдонуңуз",
    show_teeth_general: "Дарылоо карточкасындагы \"Тиштер\" өтмөгүндө жалпы талааларды көрсөтүү",
    sign_type: "Кол тамга түрү",
    sort_order: "Сорттоо тартиби",
    source: "Булак",
    sources: "Булактар",
    StaffWork: "Кызматкердин иши",
    super_user: "Суперколдонуучу",
    superadmin: "Суперадминистратор",
    superadministrators: "Суперадминистраторлор",
    supermanager: "Суперменеджер",
    SuperManager: "Администратор",
    switched_to_version_2: "2.0 версиясына которулду",
    sync_data: "Дайындарды синхрондоштуруу",
    table_settings: "Таблица орнотуулары",
    tag: "Ярлык",
    tag_id: "Белги",
    tags: "Белгилер",
    tags_for_custom_notifications: "Маалыматты автоматтык түрдө көрсөтүү үчүн тэгдер:",
    tags_for_notifications: "Маалыматты автоматтык түрдө көрсөтүү үчүн тэгдер:",
    tariff: "Тариф",
    tariff_payment_expires_in_days: "Тариф боюнча төлөө бүгүн аяктайт | Тариф боюнча төлөө {day} күндө  аяктайт | Тариф боюнча төлөө {day} күндөн кийин  аяктайт",
    tariffs: "Тарифтер",
    task_created: "Тапшырманы түзүү",
    Technic: "Техник",
    technic_salary_accrual: "Техниктер үчүн пайыздарды эсептөө логикасы",
    techsupport_panel: "Техколдоо панели",
    templates: "Шаблондор",
    templates_agreements: "Макулдук шаблондору",
    templates_categories: "Стандарттык категориялар",
    templates_contracts: "Келишим шаблондору",
    templates_for_fields: "Талаалар үчүн шаблондору",
    templates_text: "Текст шаблондору",
    templates_treatments: "Дарылоо шаблондору",
    test: "Тест",
    this_may_take_several_minutes_do_not_close_the_window: "Бул бир нече мүнөткө созулушу мүмкүн. Терезени жаппаңыз",
    time_after_visit: "визиттен кийин",
    time_before_visit: "визитке чейин",
    time_interval_value: "Убакыт интервалдарынын өлчөмү",
    time_zone: "Убакыт алкагы",
    to_billing: "Биллингти орнотууларына",
    to_the_one_who_accepted_payment: "Төлөмдү кабыл алган адамга",
    to_the_one_who_made_record: "Жазылып жаткан адамга",
    top: "Топ",
    treatment_finished: "Дарылоо аяктады",
    turn_off: "Өчүрүү",
    turn_on_autosign: "Авто-кол коюуну иштетүү",
    turned_off: "Өчүрүлгөн",
    turned_on: "Иштетилген",
    ukrainian: "Украин",
    unblock_for_3_days: "3 күнгө бөгөттөн чыгаруу",
    updated: "Өзгөртүлдү",
    use_bonuses_on_salary: "Бонустук төлөмдөр менен эмгек акыны эсептөө",
    use_proxy: "Проксини колдонуу",
    User: "Колдонуучу",
    user_id: "Колдонуучунун Id",
    UserAdditional: "Колдонуучунун кошумча маалыматтары",
    uzbek: "Өзбек",
    verify: "Текшерүү",
    'visit services sync': "Кызматтарды байланыштыруу",
    visit_cancel: "Визитти жокко чыгаруу",
    visit_comment: "Визитке комментарий",
    visit_created: "Визитти түзүү",
    visit_result: "Визиттин жыйынтыгы",
    visit_results: "Визиттин жыйынтыктары",
    visit_type: "Кабыл алуунун түрү",
    warehouse_connected: "Акы төлөнүүчү склад модулу туташтырылган",
    WarehouseInventarizationSheet: "Инвентаризация ведомосту",
    WarehouseOperation: "Кампа операциясы",
    week: "Жума",
    when_changing_tariff_all_payments_will_nullify: "Тарифти өзгөртүүдө бардык төлөмдөр жокко чыгарылат",
    which_branches_use_online_booking: "Кайсы филиалдар онлайн жазылууну колдонушат?",
    which_clients_to_consider_permanent: "Кайсы кардарлар туруктуу деп эсептелет",
    work_time_from: "Иштөө убактысы  баштап",
    work_time_to: "Иштөө убактысы  чейин",
    your_current_ip: "Сиздин учурдагы IP",
    your_tariff_plan_is_not_paid: "Сиздин тарифтик планыңыз төлөнбөгөн",
    zero_unlimited: "0 - чексиз"
}
